import http from '../_http'

const mailLog = {
  //default
  summaryMail: (m) => { return http.get(`manager/log/mail`, m); },
  listMail: (m) => { return http.post(`manager/log/mail/list`, m); },
  detailMail: (m) => { return http.get(`manager/log/mail/${m.id}`); },
}

export default mailLog

export { mailLog }